var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "12.496", height: "15", viewBox: "0 0 12.496 15" }, props),
    React.createElement(
      "g",
      { transform: "translate(-186 -265)" },
      React.createElement("path", { className: styles["a"] || "a", d: "M188.848 278.394l-1-1.486 6.693-4.5-6.693-4.5 1-1.486 8.9 5.984z" }),
      React.createElement("circle", { className: styles["a"] || "a", cx: "2.349", cy: "2.349", r: "2.349", transform: "translate(193.799 270.062)" }),
      React.createElement("circle", { className: styles["a"] || "a", cx: "2.349", cy: "2.349", r: "2.349", transform: "translate(186 265)" }),
      React.createElement("circle", { className: styles["a"] || "a", cx: "2.349", cy: "2.349", r: "2.349", transform: "translate(186 275.303)" })
    )
  );
});